export default __webpack_public_path__ + "static/media/eth-highlight.9b703a21.svg";